module.exports = __webpack_public_path__ + "img/2022_09_dandelion_oldmitsuifamily_fin_web.fd0bfcd5.jpg";